import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_EMPLOYEE_PROGRAM_PORTFOLIO_API_ID =
  'INVESTCORE/FETCH_INVESTCORE_EMPLOYEE_PROGRAM_PORTFOLIO_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_EMPLOYEE_PROGRAM_PORTFOLIO_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employee-programs/${id}/portfolio`,
    method: 'GET',
  })
);

export default apiCall;
